import { useEmbarcacaoBaseTecnica } from "../../../../hooks/use-embarcacao-base-tecnica";
import { EMPTY_FIELD_PLACEHOLDER } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  BASE_TECNICA_EMPTY_STATE,
  BASE_TECNICA_FIELDS,
  BASE_TECNICA_ID,
  BASE_TECNICA_LOADING_MESSAGE,
  BASE_TECNICA_TEST_ID,
  BASE_TECNICA_TITLE,
} from "./base-tecnica-section.constants";

/** Seção Base Técnica do detalhamento da embarcação, somente para consulta: campos já formatados na ordem da tela; campo sem valor mostra "Campo sem preenchimento". */
export function useBaseTecnicaSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, baseTecnica, errorMessage, reload } = useEmbarcacaoBaseTecnica(embarcacaoId);

  return {
    id: BASE_TECNICA_ID,
    title: BASE_TECNICA_TITLE,
    testId: BASE_TECNICA_TEST_ID,
    fieldsTestId: `${BASE_TECNICA_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: BASE_TECNICA_LOADING_MESSAGE,
    emptyContent: BASE_TECNICA_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: baseTecnica ? baseTecnica.ultimaAtualizacao : undefined,
    fields: buildDetailFields(
      baseTecnica,
      BASE_TECNICA_FIELDS,
      BASE_TECNICA_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ),
  };
}
